export default __webpack_public_path__ + "static/media/applestorelight.2d23ba69.svg";